import React from 'react';
import { Col, Row } from 'react-bootstrap';
import classNames from 'classnames';

const BidDisclaimer = ({ className }) => {
    const classes = classNames(className, 'bid-disclaimer', 'py-2 mb-1');
    return (
        <Row className={classes}>
            <Col xs={12}>
                <h5>How Bidding Works:</h5>
                <p>The bidding process is not instant. After receiving your bid the following steps will be taken:</p>
                <ul>
                    <li>Auctions close the last Friday of each month.</li>
                    <li>
                        You should receive email notification that your bid has been received within 3 business days.
                    </li>
                    <li>
                        At the end of the auction if any additional information is required you will be contacted by
                        email.
                    </li>
                    <li>
                        The Muncie Land Bank will review all bids and select the highest and best bid for each property.
                    </li>
                    <li>After the review process all bidders will be contacted by email</li>
                </ul>
            </Col>
            <Col xs={12}>
                <h5>
                    <small>
                        The submission of a bid is a statement of interest only. By receiving this bid, the Muncie Land
                        Bank does not commit to the transfer of the property.
                    </small>
                </h5>
            </Col>
        </Row>
    );
};

export default BidDisclaimer;
